module.exports = __webpack_public_path__ + "img/dzpk.84e47828.jpg";